const GTAG_ID = "AW-18097874472";
const CONVERSION_SEND_TO = "AW-18097874472/D_t4COjwxd0cEKjM3rVD";

/** Google Ads 落地页 source 下的 Steam 商店链接 */
export const STEAM_URL_GOOGLE =
    "https://store.steampowered.com/app/4517160/Piroker/?utm_source=googleads&utm_campaign=PR-ALL-Youtube-goal-webD-01-0805-f";

/** 默认官网 Steam 商店链接 */
export const STEAM_URL_DEFAULT =
    "https://store.steampowered.com/app/4517160/?utm_source=official_website&utm_campaign=home&utm_medium=web&utm_content=steam_button";

function getUrlParam(key) {
    try {
        return new URLSearchParams(window.location.search).get(key) || "";
    } catch (e) {
        return "";
    }
}

export const isGoogleSource = getUrlParam("source") === "google";

export function getSteamStoreUrl() {
    return isGoogleSource ? STEAM_URL_GOOGLE : STEAM_URL_DEFAULT;
}

function loadGtag() {
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
    script.onerror = function () {
        console.error("[gg] Failed to load gtag:", script.src);
    };
    document.head.appendChild(script);
}

if (isGoogleSource) {
    loadGtag();
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GTAG_ID);
}

/**
 * Google Ads Outbound click conversion
 * @param {string} [name] 点击名称（仅用于日志）
 * @param {string} [url] 若传入，转化回调后会跳转到该地址
 */
export function gtagReportClick(name, url) {
    if (!isGoogleSource) {
        console.log("[gg] skipped (source != google)", name);
        if (typeof url !== "undefined") {
            window.location = url;
        }
        return false;
    }
    if (typeof window.gtag !== "function") {
        console.warn("[gg] gtag not ready", name);
        if (typeof url !== "undefined") {
            window.location = url;
        }
        return false;
    }
    console.log("[gg] report conversion", name);
    var callback = function () {
        if (typeof url !== "undefined") {
            window.location = url;
        }
    };
    window.gtag("event", "conversion", {
        send_to: CONVERSION_SEND_TO,
        event_callback: callback,
    });
    return false;
}



// WEBPACK FOOTER //
// ./src/utils/gg.js